/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_Reminder_WordsInputs */

const en_us2_search_field_reminder_words = /** @type {(inputs: Search_Field_Reminder_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`notification notifications reminder time alarm alert`)
};

const pt_br2_search_field_reminder_words = /** @type {(inputs: Search_Field_Reminder_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`notificacao notificacoes lembrete horario alarme aviso`)
};

const es_419_search_field_reminder_words = /** @type {(inputs: Search_Field_Reminder_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`notificacion notificaciones recordatorio hora alarma aviso`)
};

const pt_pt2_search_field_reminder_words = /** @type {(inputs: Search_Field_Reminder_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`notificacao notificacoes lembrete horario alarme aviso`)
};

const fr_fr2_search_field_reminder_words = /** @type {(inputs: Search_Field_Reminder_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`notification notifications rappel heure alarme alerte`)
};

const de_de2_search_field_reminder_words = /** @type {(inputs: Search_Field_Reminder_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`benachrichtigung benachrichtigungen erinnerung uhrzeit wecker hinweis`)
};

const it_it2_search_field_reminder_words = /** @type {(inputs: Search_Field_Reminder_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`notifica notifiche promemoria orario sveglia avviso`)
};

/**
* | output |
* | --- |
* | "notification notifications reminder time alarm alert" |
*
* @param {Search_Field_Reminder_WordsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_reminder_words = /** @type {((inputs?: Search_Field_Reminder_WordsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_Reminder_WordsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_reminder_words(inputs)
	if (locale === "es-419") return es_419_search_field_reminder_words(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_reminder_words(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_reminder_words(inputs)
	if (locale === "de-DE") return de_de2_search_field_reminder_words(inputs)
	if (locale === "it-IT") return it_it2_search_field_reminder_words(inputs)
	return en_us2_search_field_reminder_words(inputs)
});
export { search_field_reminder_words as "search.field_reminder_words" }